
import Vector from "../Vector";
import GameObject from "./GameObject";

export type PositionObjectOptions = {
	x?: number
	y?: number
}

export default class PositionObject extends GameObject {

	position = new Vector(0, 0)

	constructor({ x = 0, y = 0 }: PositionObjectOptions) {
		super()
		this.position.x = x;
		this.position.y = y;
	}
}